import './Homepage.scss'

import { useEffect, useState } from 'react'
import { useCharacters } from '../../../contexts/Characters'
import { useData } from '../../../contexts/Data'
import { useToaster } from '../../../contexts/Toaster'
import { useReady } from '../../../contexts/Ready'
import { capitalize } from '../../../utilities/helpers'
import { hours } from '../../../utilities/constants'
import { Link } from 'react-router'
import koalition from '../../../api/koalition'
import useCurrentTime from '../../../hooks/CurrentTimeHook'
import Event from '../../domain/Event/Event'

const Homepage = () => {
    const characters = useCharacters()
    const data = useData()
    const toaster = useToaster()
    const ready = useReady()
    const eventScopes = ['server', 'alliance']
    const currentTime = useCurrentTime()
    const [recentEvents, setRecentEvents] = useState([])

    useEffect(() => {
        setRecentEvents(eventScopes.map((scope) => (data.$state[`${scope}Events`] || [])
            .map((event) => ({ ...event, scope }))).flat()
            .filter((event) => {
                const isOngoing = event.startDate < currentTime
                const startsSoon = (event.startDate - currentTime) < (24 * hours)

                return isOngoing || startsSoon
            })
            .sort((event1, event2) => event1.startDate - event2.startDate)
        )
    }, [data.$state.allianceEvents, data.$state.serverEvents])

    useEffect(() => {
        if (characters.$state.current) {
            eventScopes.forEach((scope) => {
                const scopeDataKey = `${scope}Events`
                const scopeId = characters.$state.current?.[scope]?._id
                const scopeChanged = characters.$state.previous && scopeId && scopeId !== characters.$state.previous[scope]?._id
                const firstLoad = !characters.$state.previous && !data.$state[scopeDataKey]
                if (scopeChanged || firstLoad) {
                    data.save(scopeDataKey, [])
                    if (characters.$state.current?.[`accepted${capitalize(scope)}`]) {
                        koalition.get(`/events?${scope}=${characters.$state.current?.[scope]?._id}`).then((response) => {
                            data.save(scopeDataKey, response.data)
                            ready.set(scopeDataKey)
                        }).catch((error) => {
                            toaster.error(error)
                            console.error(error)
                        })
                    }
                }
            })
        }
    }, [characters.$state.current])

    return (
        <div className="container-fluid homepage">
            <div className="row">
                <div className="col-xl-7 pane left">
                    <div className="card semi-dark events mb-4">
                        <h3 className="mb-4">Recent Events</h3>
                        {ready.$state.serverEvents && ready.$state.allianceEvents && <>
                            {!!recentEvents.length ? (
                                <ul>
                                    {recentEvents.map((event) => (
                                        <li className="mb-3" key={event._id}>
                                            <Event event={event} />
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p className="text-center">No recent event has been scheduled yet. Visit the <Link to="/events">events page</Link> for the full list.</p>
                            )}
                        </>}
                    </div>
                </div>

                <div className="col-xl-5 pane right"></div>

                <div className="col-12 pane bottom"></div>
            </div>
        </div>
    )
}

export default Homepage